import { FC, PropsWithChildren, useMemo } from 'react';
import { IOfferCardWidgetProps } from '../../types';
import { prepareGallery, prepareGeneralInfo, prepareOffer, preparePublisher } from './mappers';
import { OfferCardContext } from '../../context/offerCardContext';
import { IOfferCardContext } from '../../types/offerContext';

type TOfferContextProvider = Omit<IOfferCardWidgetProps, 'context'>;

export const OfferCardContextProvider: FC<PropsWithChildren<TOfferContextProvider>> = ({
  children,
  offer,
  user,
  onPhoneShow,
  onChatButtonClick,
  onChatPopupOpen,
  onFavoritesAdd,
  onFavoritesRemove,
  onComparisonAdd,
  onComparisonRemove,
}) => {
  /**
   * В контексте лежит весь статичный вычисляемый контент сниппета по блокам
   * + сам оффер и юзер для вычисления динамического контента
   */
  const context: IOfferCardContext = useMemo(
    () => {
      const offerCard = { ...offer, offerUser: offer.user, user };

      return {
        // блок галереи
        gallery: prepareGallery(offerCard),
        // блок основной информации
        generalInfo: prepareGeneralInfo(offerCard),
        // блок автора
        publisher: preparePublisher(offerCard),
        // расширенный объект объявления
        offer: prepareOffer(offer),
        // объект юзера
        user,
        // объект коллбеков для трекинга
        tracking: {
          onPhoneShow,
          onChatButtonClick,
          onChatPopupOpen,
          onFavoritesAdd,
          onFavoritesRemove,
          onComparisonAdd,
          onComparisonRemove,
        },
      };
    },
    [], // eslint-disable-line
  );

  return <OfferCardContext.Provider value={context}>{children}</OfferCardContext.Provider>;
};
